import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=35156f02&"
import script from "./EditBrand.vue?vue&type=script&lang=js&"
export * from "./EditBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports